__turbopack_context__.v({
  "dropzone": "_0T1XIa_dropzone",
  "error": "_0T1XIa_error",
});
